import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class SignifiLogServices {
    static getLogs(filters = null) {
        return HTTP.get(`signifi-logs`, {
            params: {
                ...filters
            }
        }).then((response) => {
            return {
                data: response.data.signifiLogs,
                meta: response.data.meta
            }
        }).catch(() => {
            return Promise.reject('Could not get End Point');
        });
    }
}

export default SignifiLogServices;
